import React from "react";
import { Hidden } from "@origin-digital/ods-core";
import { logger } from "@origin-digital/reporting-client";
import { useLocation } from "react-router-dom";
import { useAppContext } from "../../AppContext";
import { findLabel } from "../../helpers/mapping";
import { Path, PathnameMap } from "../../interfaces/breadcrumbs";
import { Breadcrumbs } from "./Breadcrumbs";

const basePath = "/help-support";
const baseDisplayName = "Help & Support";

export const BreadcrumbsController = (): JSX.Element => {
  const location = useLocation();
  const { navigation } = useAppContext();
  const categories = ((navigation || {}).data || {}).categories;

  const [pathnameMap, setPathnameMap] = React.useState<PathnameMap>({});
  // TODO fix this to useParams()
  const pathnames = location.pathname.split("/").filter((x) => x !== "");
  logger.debug(`Creating breadcrumbs for ${location.pathname}`);

  React.useEffect(() => {
    if (categories) {
      const map: PathnameMap = { [basePath]: baseDisplayName };
      const paths: Path[] = Object.keys(map);

      pathnames.forEach((pathname) => {
        const result = findLabel(categories, pathname);
        if (result) {
          logger.debug(`Label found for pathname: ${pathname}.`);
          paths.push(result.name);
          map[paths.join("/")] = result.displayName;
        } else {
          logger.warn(`Label not found for pathname: ${pathname}.`);
        }
      });
      setPathnameMap(map);
    }
  }, [categories, location.pathname]);

  return (
    <Hidden below="md">
      <Breadcrumbs pathnameMap={pathnameMap} pathname={location.pathname} />
    </Hidden>
  );
};
